
import { defineComponent, onBeforeMount, reactive } from 'vue'
import sponsorAdsData from '@/../public/json/sponsor-ads.json'

type ArrayElement<ArrayType extends readonly unknown[]> = ArrayType[number];
type AdData = ArrayElement<typeof sponsorAdsData.ads>

interface AdList {
  verticalLeft: AdData | null;
  verticalRight: AdData | null;
  horizontalBottom: AdData | null;
}

export default defineComponent({
  name: 'SessionPopupContainer',
  setup () {
    const ads: AdList = reactive({
      verticalLeft: null,
      verticalRight: null,
      horizontalBottom: null
    })

    onBeforeMount(() => {
      const numOfAds = sponsorAdsData.ads.length
      ads.verticalLeft = sponsorAdsData.ads[Math.floor(Math.random() * numOfAds)]
      ads.verticalRight = sponsorAdsData.ads[Math.floor(Math.random() * numOfAds)]
      ads.horizontalBottom = sponsorAdsData.ads[Math.floor(Math.random() * numOfAds)]
    })

    return {
      ads
    }
  }
})
